const globalStyles = {
  addSaveListButtonClassName: "inline-flex justify-center p-1 mr-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
  textBox: "form-control block w-500 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none",
  labels: "form-label inline-block mb-2 text-gray-700"
}

export { globalStyles }